import {invariant} from '@react-dnd/invariant'
import {useContext, useEffect, useState} from 'react'
import {DndContext} from 'react-dnd'

const useDragOffsetDiff = (enabled, fps = 60) => {
  const {dragDropManager} = useContext(DndContext)
  invariant(dragDropManager != null, 'Expected drag drop context')
  const monitor = dragDropManager.getMonitor()
  const [dragOffsetDiff, setDragOffsetDiff] = useState(monitor.getDifferenceFromInitialOffset())
  const offsetChangeListener = () => setDragOffsetDiff(monitor.getDifferenceFromInitialOffset())
  const [intervalId, setIntervalId] = useState()
  const cleanup = () => {
    if (intervalId) {
      clearInterval(intervalId)
      setDragOffsetDiff({x: 0, y: 0})
    }
  }
  useEffect(() => {
    if (enabled) {
      setIntervalId(setInterval(() => {
        offsetChangeListener()
      }, 1000 / fps))
    } else {
      cleanup()
    }
    return cleanup
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])
  return dragOffsetDiff
}

export default useDragOffsetDiff;
